export default "__VITE_ASSET__fTrplfif__"